import { ActionType, IAction } from '../../constants';

export const setLanguage = (lang: string): IAction =>{
  return {
    type: ActionType.SET_LANGUAGE,
    payload: lang,
  }
}
